import React from "react";

interface PaymentOptionProps {
  label: string;
  image: string;
  alt: string;
  onClick: () => void;
}

const PaymentOption: React.FC<PaymentOptionProps> = ({ label, image, alt, onClick }) => {
  return (
    <button onClick={onClick} className="payment-option group">
      <img src={image} alt={alt} className="payment-image group-hover:scale-110 group-hover:shadow-lg" />
      <span className="payment-label">{label}</span>
    </button>
  );
};

export default PaymentOption;
